export const brandConfig = {
  name: 'NEXO COMERCIO',
  shortName: 'NEXO',
  description: 'Vende, controla y muestra tu negocio desde un solo lugar',
  supportEmail: 'soporte@ejemplo.com',
  supportWhatsApp: '',
  website: '',
  legalName: 'Nombre legal pendiente',
  domain: 'nexocomercio.app',
  colors: {
    primary: '#163d36',
    accent: '#e49b5d',
  },
  logoPath: '/nexo-mark.svg',
} as const;
